import React from "react";
import { Grid, Box } from "@material-ui/core";
import useStyles from "../common/Styles";
import AboutTogglebar from "../common/AboutTogglebar";
import ChartView from "./ChartView";
import { charts, about } from "./constants";
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import AgricultureMetrics from "./AgricultureMetrics";
import MiniMetrics from "./MiniMetrics";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import toggleIcon from '../../../../assets/slide-out-icon.png';

const AgricultureView = () => {
  const classes = useStyles();
  const { chart_selected, toggle_about } = useSelector((state) => state.water_user);
//   const { setWaterUserChart } = userActions();
  const { toggleAboutDrawer } = userActions();
  const { windowDimension } = useGetViewPortDimensions();

  return (
    <Grid container item style={{ width: windowDimension.winWidth, flexDirection: 'column', zIndex: 1 }}>
      {!toggle_about ? (
            <Grid item>
                <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
            </Grid>
            ) : (
                <Box className={classes.aboutDrawerResponsive}>
                    <AboutTogglebar
                        MetricsComponent={
                        {
                            0: <AgricultureMetrics />,
                            1: <MiniMetrics />,
                            2: <AgricultureMetrics />
                        }[chart_selected >= charts.length ? 0 : chart_selected]
                        }
                        about={about[chart_selected >= charts.length ? 0 : chart_selected]}
                    />
                </Box>
            )}
            {!toggle_about ? (
                <Grid container item justify="center" alignItems="center" className={classes.aboutTogglebarResponsive} onClick={toggleAboutDrawer}>
                    <img src={toggleIcon} className={classes.aboutToggleIconResponsive} alt="response-icon.png" />
                </Grid>
            ) : null}
    </Grid>
  );
};

export default AgricultureView;
